export const LOAD_REFERRAL_CRYPTO_WALLETS = 'LOAD_REFERRAL_CRYPTO_WALLETS';
export const SET_REFERRAL_CRYPTO_WALLETS = 'SET_REFERRAL_CRYPTO_WALLETS';

export const loadCryptoWallets = () => ({
  type: LOAD_REFERRAL_CRYPTO_WALLETS
});

export const setReferralCryptoWallets = payload => ({
  type: SET_REFERRAL_CRYPTO_WALLETS,
  payload
});

const initialState = {
  loading: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_REFERRAL_CRYPTO_WALLETS:
      return {
        ...state,
        referralCryptoWallets: action.payload,
        loading: false
      };
    default:
      return state;
  }
};
